export function reportWebVitals(metric) {
  if (metric) {
    console.log(metric);
  }
}